import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-178fdd3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card reports--room" }
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}

import { computed, ref, provide } from 'vue';
import { useStore } from 'vuex';
import { checkitem } from '@/utilities';
import { Section, Type, Item, Room } from "@/models";
import ReportRoomSection from './Section.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Room',
  props: {
    index: {},
    room: {},
    toggle: { type: Boolean },
    opened: { type: Boolean }
  },
  emits: ['showBody'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const store = useStore();
const props = __props;

provide('roomIndex', props.index);

const showBody = ref(true);

const _toggle = computed(() => props.toggle);
const _opened = computed(() => props.opened);
const _room = computed(() => props.room);
const _index = computed(() => props.index);

const sectionswithdeductions = computed(() => {
  return _room.value?.sections?.filter((section: Section) =>
    checksection(_room.value, section)
  ) ?? [];
});

function getSectionIndex(section: Section): number {
  return _room.value.sections.findIndex((s: Section) => s._uuid === section._uuid);
}

function checksection(room: Room, section: Section): boolean {
  let result = section.types.filter((type: Type) =>
    checktype(room, section, type)
  );
  return result.length > 0;
}

function checktype(room: Room, section: Section, type: Type): boolean {
  let result = type.items.filter((item: Item) =>
    checkitem(room, section, type, item)
  );
  return result.length > 0;
}

function toggleShowBody(): void {
  store.commit('reports/setCurrentRoom', _room.value);
  if (_toggle.value) {
    showBody.value = !_opened.value;
    emit("showBody", _index.value, showBody.value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-header", { 'toggle-body': _toggle.value }])
    }, [
      _createElementVNode("h2", {
        class: "mb-0",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleShowBody()), ["self"]))
      }, _toDisplayString(_room.value.name), 1)
    ], 2),
    (_opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectionswithdeductions.value, (section) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section._uuid
            }, [
              (section.types.length)
                ? (_openBlock(), _createBlock(ReportRoomSection, {
                    key: 0,
                    room: _ctx.room,
                    section: section,
                    index: getSectionIndex(section)
                  }, null, 8, ["room", "section", "index"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})